module.exports = __webpack_public_path__ + "img/listArrow-r-a.3356b0fa.svg";